var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54576 10.2007H15.0439L11.913 7.02282C11.253 6.32525 11.2585 5.22352 11.9348 4.53701C12.6058 3.85604 13.6967 3.84497 14.3839 4.51487L20.493 10.7156C21.1748 11.4076 21.1748 12.5315 20.493 13.2235L14.3839 19.4242C14.0567 19.7675 13.6094 19.9612 13.1458 19.9668C12.6767 19.9723 12.2294 19.7841 11.8967 19.4464C11.5639 19.1086 11.3839 18.6547 11.3839 18.1785C11.3894 17.7024 11.5803 17.2484 11.9185 16.9218L15.0439 13.7439H4.54576C3.5803 13.7439 2.8003 12.9522 2.8003 11.9723C2.8003 10.9924 3.5803 10.2007 4.54576 10.2007Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHorizontal);
export default __webpack_public_path__ + "static/media/ArrowHorizontal.766c5f52.svg";
export { ForwardRef as ReactComponent };